import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EdaraSetupService } from '@core/services/edara-setup.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent {

  constructor(
    private router: Router,
    private edaraSetupService: EdaraSetupService
  ) {
    this.checkEdaraSetup();
  }

  private async checkEdaraSetup(): Promise<void> {
    const isSetupCompleted = await this.edaraSetupService.checkEdaraSetupCompleted();
    if (!isSetupCompleted) {
      this.router.navigate(['/system/edara-setup']);
    }
  }

}
